import { Flex, theme } from 'antd';
import { FC, memo } from 'react';
import { PatchExclamation } from 'react-bootstrap-icons';

import { AppAutocomplete } from '@/common/components';
import { AppAutocompleteComponentProps } from '@/common/interfaces';
import { parseSelectData } from '@/common/utils';

import { useAutocompleteSearchConsoleAccountsQuery } from '@/modules/DomainsApi';

interface Props extends AppAutocompleteComponentProps {}

export const SearchConsoleAccountsAllAutocomplete: FC<Props> = memo((props) => {
  const { token } = theme.useToken();

  return (
    <AppAutocomplete<typeof useAutocompleteSearchConsoleAccountsQuery>
      {...props}
      optionItemRender={({ isReadyToUse, email }) => (
        <Flex align="center" justify="space-between" gap={8}>
          <span>{email}</span>
          {!isReadyToUse && <PatchExclamation color={token.colorError} />}
        </Flex>
      )}
      options={(data) =>
        parseSelectData(data, {
          value: 'id',
          label: 'email',
          disabled: (item) => !item.isReadyToUse,
        })
      }
      notFoundDescription={'Немає акаунтів Search Console'}
      placeholder={'Знайдіть акаунт Search Console'}
      query={useAutocompleteSearchConsoleAccountsQuery}
    />
  );
});
